import { Button } from '@/components/Button';
import { getUrl } from '@/utils/getUrl';
import { withTrackingAttributes } from '@/utils/withTrackingAttributes';
import { StandaloneBanner } from 'base/components/Banner';
import Tracking from 'base/components/TrackingComponent';
import BackgroundImage from 'base/public/image/banner-games-image.svg';
import { getOcelotConfig } from 'lib/configs/ocelot';

const { frontPagePathname } = getOcelotConfig('features.keesingGames');
const ctsUrl = getUrl(frontPagePathname);
const ctsAttrs = withTrackingAttributes({
  category: 'promotion_banner',
  name: 'teaser',
  url: ctsUrl ? ctsUrl.toString() : frontPagePathname,
  extraInfo: [{ campaign: 'keesing_games' }],
});

export const AllasStandaloneBanner: typeof StandaloneBanner = (props) => {
  const backgroundImageMemo = <BackgroundImage />;
  const contentMemo = (
    <>
      <h1>Nyhet!</h1>
      <h1>Korsord, sudoku och spel</h1>
      <Button
        href={frontPagePathname}
        content={'Klicka här för att spela'}
        options={{ size: 'large', className: 'self-start' }}
      />
    </>
  );

  return (
    <Tracking options={{ wrapChildren: true, ctsAttrs }}>
      <StandaloneBanner content={contentMemo} backgroundImage={backgroundImageMemo} {...props} />
    </Tracking>
  );
};
